import { useTranslation } from "react-i18next";

const whyCards = [
  {
    icon: "ri-time-line",
    key: "why.card1",
  },
  {
    icon: "ri-stack-line",
    key: "why.card2",
  },
  {
    icon: "ri-scales-3-line",
    key: "why.card3",
  },
  {
    icon: "ri-shield-check-line",
    key: "why.card4",
  },
];

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 md:mb-4">
            {t("why.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {whyCards.map((card, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-100 flex items-center justify-center mb-4 md:mb-5 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${card.icon} text-accent-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2 md:mb-3">
                {t(`${card.key}_title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`${card.key}_desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}